export default __webpack_public_path__ + "static/media/3.aed75279.svg";